import { RISKPROF_INIT_LOADING, RISKPROF_INIT_SUCCESS, RISKPROF_INIT_FAIL } from '@/store/types'
import http from '@/utils/ajax'
import clone from 'clone'
import { extractMenu, extractMessages } from '@/utils/extract'

export const initialState = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [RISKPROF_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [RISKPROF_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [RISKPROF_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async riskProfManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.riskProfManagement
    commit(RISKPROF_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(RISKPROF_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(RISKPROF_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
